const PRESET_DAY_COUNTS = [7, 30, 60, 90] as const;

export function parseLocalCalendarDate(dateStr: string): Date {
  const match = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) {
    return new Date(dateStr);
  }
  const [, year, month, day] = match;
  return new Date(Number(year), Number(month) - 1, Number(day));
}

export function formatLocalCalendarDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getLocalToday(): string {
  return formatLocalCalendarDate(new Date());
}

/** N días calendario inclusivos: hoy y los (N-1) días anteriores. */
export function getPresetDateRange(dayCount: number): { start: string; end: string } {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - (dayCount - 1));

  return {
    start: formatLocalCalendarDate(start),
    end: formatLocalCalendarDate(end),
  };
}

export function calendarDaysInclusive(start: string, end: string): number {
  const startDate = parseLocalCalendarDate(start);
  const endDate = parseLocalCalendarDate(end);
  const diffMs = endDate.getTime() - startDate.getTime();
  return Math.floor(diffMs / 86_400_000) + 1;
}

export function detectDateRangePreset(start: string, end: string): string {
  if (end !== getLocalToday()) {
    return 'custom';
  }

  const spanDays = calendarDaysInclusive(start, end);
  const match = PRESET_DAY_COUNTS.find((count) => count === spanDays);
  return match ? String(match) : 'custom';
}

export function formatDateRangeLabel(start: string, end: string): string {
  const formatter = new Intl.DateTimeFormat('es-AR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });

  return `${formatter.format(parseLocalCalendarDate(start))} – ${formatter.format(parseLocalCalendarDate(end))}`;
}
